import { apiClient } from '@/lib/api-client'
import { Visit, VisitOutcome } from '@shared/types/entities'

export interface CreateVisitRequest {
  businessId: string
  startLatitude: number
  startLongitude: number
  distanceOverridden?: boolean
}

export interface CompleteVisitRequest {
  endLatitude: number
  endLongitude: number
  notes?: string
  outcome: VisitOutcome
  photoUrls?: string[]
}

export interface PhotoPresignedRequest {
  visitId: string
  fileName: string
  contentType: string
}

export interface PhotoPresignedResponse {
  uploadUrl: string
  photoUrl: string
  photoId: string
}

export const visitService = {
  create: (data: CreateVisitRequest, token: string) =>
    apiClient.post('/visits', data, token),

  get: (visitId: string, token: string) =>
    apiClient.get(`/visits/${visitId}`, token),

  list: (token: string) =>
    apiClient.get('/visits', token),

  listByScout: (scoutId: string, token: string) =>
    apiClient.get(`/visits?scoutId=${scoutId}`, token),

  complete: (visitId: string, data: CompleteVisitRequest, token: string) =>
    apiClient.post(`/visits/${visitId}/complete`, data, token),

  getPhotoPresignedUrl: (data: PhotoPresignedRequest, token: string) =>
    apiClient.post('/visits/photos/presigned', data, token),

  uploadPhoto: async (uploadUrl: string, file: File): Promise<void> => {
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    })
  },
}
